/**
 * Display a choice with a picture, a name, description and price
 * shape parameter allow to show image as a cicle or a square
 */
fx.ns("shared.components", class ProductChoice extends fx.components.VBox
{    
    constructor(shape, data, image, name, description, price)
    {
        super();

        this.data = data;
        this.image = image;
        this.name = name; 
        this.description = description;
        this.price = price;

        this._display = shape || "circle";
    }

    create()
    {
        super.create();

        this.addChild( new fx.components.ImageButton( {image : this.image } ), {width:"100%", left : "center"} );

        if (this.name)
            this.addChild( new fx.components.Text( {text : this.name, className : "name"} ), {width:"100%", height : 25, left : "center"} );

        if (this.description)
            this.addChild( new fx.components.Text( {text : this.description, className : "description"} ), {width:190, left : "center"} );

        if (this.price)
            this.addChild( new fx.components.Text( {text : this.price, className : "price"} ), {width:190, left : "center"} );

        this.addClass(this._display)
    }

});
